import {
  Layout,
  Table,
  PageHeader,
  notification,
} from "antd";
import "./style.css";
import React, { Component } from "react";
import { connect } from "react-redux";
import getColumn from "./column";
import { fetchMenuAction } from "../../store/actions/leftSideMenu";
import SearchField from "./form";
import service from "./service";
import { UserSellPriceForm } from "../User/UserManagement/UserSellPriceModal";
const routes = [
  {
    path: "index",
    breadcrumbName: "Offer Management",
  },
];

class OfferManagementPage extends Component {
  state = {
    loading: true,
    dataSource: [],
    defaultSearch: null,
    showInputModal: false,
    countryList: [],
    flagCreateOrUpdateForm: true,
    actionVisible: false,
    currentData: {},
    revisionList: [],
    page: 1,
    search: "",
    limit: 10,
    rows: 0,
  };

  componentWillMount() {
    this.props.fetchMenuAction("offer", "offer");
    this.setState({ loading: true });
  }

  async componentDidMount() {
    const { page, search, limit } = this.state;
    const list = await service.getOfferList(page, limit, search);
    const countryList = await service.getCountryList();
    const revisionList = await service.getRevisionList();

    this.setState({
      dataSource: list["data"],
      countryList: countryList,
      revisionList: revisionList,
      rows: list["total_rows"],
      loading: false,
    });
  }

  async handleOnSearch(page, search) {
    const list = await service.getOfferList(page, this.state.limit, search);
    this.setState({
      dataSource: list["data"],
      rows: list["total_rows"],
      loading: false,
    });
  }

  handleOnSwtichStatus = async (record, status) => {
    let res;
    this.setState({
      loading: true,
    });

    try {
      res = await service.updateStatus(record.id, status);
      notification.success({
        message: "การเพิ่มข้อมูลเสร็จสิ้น",
      });
    } catch (error) {
      notification.error({
        message: res.error.name,
        description: res.error.description,
      });
    }
    this.handleOnSearch(this.state.page, this.state.search);
  };

  handleOnPagination({ current }) {
    this.setState({
      page: current,
      loading: true,
    });

    this.handleOnSearch(current, this.state.search);
  }

  handleOnFilter = (value) => {
    this.setState({
      search: value,
    });

    this.handleOnSearch(1, value);
    sessionStorage.removeItem("page-el-limit");
  };

  triggerAdd = () => {
    this.setState({
      actionVisible: true,
      flagCreateOrUpdateForm: true,
      currentData: { offer_id: 0 },
    });
  };

  triggerUpdate = (record) => {
    let renewObject = record;
    renewObject = { ...record, rates: record["price"], offer_id: record.id };

    this.setState({
      actionVisible: true,
      flagCreateOrUpdateForm: false,
      currentData: renewObject,
    });
  };

  formHandleCancel = () => {
    this.setState({
      actionVisible: false,
      currentData: {},
      flagCreateOrUpdateForm: true,
    });
  };

  formHandleSubmit = (form) => {
    const work = {
      create: async (payload) => await service.addOffer(payload),
      update: async (payload) => await service.updateOffer(payload),
    };
    form.validateFields(async (err, values) => {
      if (err) {
        return;
      }

      let payload = values;
      let key = "update";

      // ? rename key
      payload["price"] = parseFloat(values["rates"]);

      // ? add time to expired-date

      const tmpDate = values["expired"].endOf("day").format("YYYY-MM-DD HH:mm:ss");
      payload["expired"] = tmpDate
      delete payload.rates;

      // ? classify action by member_id, if payload has `member_id` its mean this action will going to be the creation.
      if (values["member_id"]) {
        key = "create";
        payload = { ...values, country_abbr: values["region_code"] };
      }

      // ? work
      const res = await work[key](payload);
      const result = service.handlerError(res);

      // ? handle event when work is done
      if (!result) {
        return;
      }

      // ? reset state
      this.setState({
        actionVisible: false,
        currentData: {},
      });

      // ? re-fetech data
      this.handleOnSearch(this.state.page, this.state.search);
    });
  };

  render() {
    const propsTable = {
      className: "my-table",
      columns: getColumn(
        this.state.countryList,
        this.handleOnSwtichStatus,
        this.triggerUpdate
      ),
      dataSource: this.state.dataSource,
      rowKey: "id",
      pagination: {
        total: this.state.rows,
        showTotal: (total, range) =>
          `Users ${range[0]} - ${range[1]} of ${total}`,
        defaultCurrent: 1,
        defaultPageSize: this.state.limit,
      },
      loading: this.state.loading,
      onChange: (page) => this.handleOnPagination(page),
    };

    return (
      <Layout className="my-layout">
        <PageHeader
          style={{
            backgroundColor: "#f0f2f5",
          }}
          breadcrumb={{ routes }}
          title={<h2 style={{ fontWeight: "bold" }}>Offer Management</h2>}
        />

        <div className="offer-container">
          <SearchField
            onCreate={this.triggerAdd}
            revisionList={this.state.revisionList}
            countryList={this.state.countryList}
            cb={(value) => this.handleOnFilter(value)}
          />
          <Table {...propsTable} />
          <UserSellPriceForm
            visible={this.state.actionVisible}
            countryList={this.state.countryList}
            flagCreateOrUpdateForm={this.state.flagCreateOrUpdateForm}
            onCancel={this.formHandleCancel}
            onSubmit={this.formHandleSubmit}
            data={this.state.currentData}
            newLogic={true}
          />
        </div>
      </Layout>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headerBarStore: state.headerBar,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchMenuAction: (menuParentKey, menuKey) =>
      dispatch(fetchMenuAction(menuParentKey, menuKey)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(OfferManagementPage);



// WEBPACK FOOTER //
// ./src/containers/OfferManagement/index.js